var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('footer',{staticClass:"pb-5 text-center"},[_c('br'),_c('br'),_c('div',{staticClass:"text-muted small"},[_vm._v(" © Roshan Saganti. All Rights Reserved. 2024. ")])])])
}]

export { render, staticRenderFns }